import React, { useEffect } from "react";
import { Button, Col, Form, Input, Row, Space } from "antd";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";

import BBSEditor from "./BBSEditor";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RentRegisterFap({
    editMode,
    faq,
    onResult,
}: {
    editMode: "view" | "update" | "register";
    faq?: Types.RentFaqDto;
    onResult: (faq: Types.RentFaqDto) => void;
}) {
    const [form] = Form.useForm();

    useEffect(() => {
        editMode === "register" && form.resetFields();
    }, [editMode]);

    useEffect(() => {
        if (!faq) return;
        form.setFieldsValue(faq);
    }, [faq]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const faq: Types.RentFaqDto = {
            ...values,
        };

        onResult(faq);
    };

    return (
        <>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <div>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    className="searchForm"
                                    {...formItemLayout}
                                    name="faqQuestion"
                                    label="FAQ 질문"
                                    rules={[
                                        {
                                            required: true,
                                            message: "질문을 입력해 주세요.",
                                        },
                                    ]}
                                >
                                    {editMode === "register" ? <Input placeholder={String.title} /> : <Input value={faq?.faqQuestion} />}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item className="searchForm" {...formItemLayout} name="rentFaqId" label="FAQ ID">
                                    <Input readOnly />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item className="searchForm" {...formItemLayout} name="faqOrder" label="FAQ 순서">
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    className="searchForm"
                                    {...formItemLayout}
                                    name="faqAnswer"
                                    label="FAQ 답변"
                                    rules={[
                                        {
                                            required: true,
                                            message: "답변을 입력해 주세요.",
                                        },
                                    ]}
                                >
                                    {editMode === "register" ? <BBSEditor hasAttachFiles={false} /> : <BBSEditor value={faq?.faqAnswer} />}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "register" ? String.add : String.update}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </>
    );
}

export default RentRegisterFap;
